'use client';

import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: false;
    md: false;
    lg: false;
    xl: false;
    mobile: true; // adds the `mobile` breakpoint
    tablet: true;
    laptop: true;
    desktop: true;
  }
}

const appTheme = createTheme({
  palette: {
    primary: {
      main: '#0050b3',
    },
    error: {
      main: '#b91c1c',
    },
    text: {
      primary: '#2d2d2d',
    },
  },
  typography: {
    fontFamily: 'inherit',
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: '0 20px',
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(226, 232, 240, 0.4)',
        },
        rounded: {
          borderRadius: '8px',
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontSize: '1rem',
          lineHeight: 1.5,
          fontWeight: 600,
          borderRadius: '8px',
        },
        outlined: {
          backgroundColor: '#fff',
          border: '1px solid #0050b3',
          ':hover': { backgroundColor: '#eef1fe' },
        },
        contained: {
          ':hover': { backgroundColor: '#003a8c' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: '8px' },
      },
    },
    MuiTooltip: {
      defaultProps: {
        disableTouchListener: true,
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      mobile: 0,
      tablet: 640,
      laptop: 1024,
      desktop: 1200,
    },
  },
});

export default appTheme;
